<!-- eslint-disable max-len -->
<template>
<svg
    width="46" height="48" viewBox="0 0 46 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <g clip-path="url(#clip0_459_24107)">
        <path
            opacity="0.2"
            d="M12.2871 10.0312C10.6979 13.4079 9.39822 16.9133 8.40212 20.5098C8.16541 21.3808 8.10299 22.29 8.21842 23.1852C8.33386 24.0803 8.62489 24.9439 9.07482 25.7264C9.52475 26.5088 10.1247 27.1947 10.8403 27.7448C11.5559 28.2949 12.3731 28.6982 13.245 28.9318C14.1168 29.1653 15.0262 29.2244 15.9209 29.1058C16.8157 28.9871 17.6782 28.6929 18.459 28.2401C19.2398 27.7874 19.9236 27.1849 20.471 26.4673C21.0185 25.7497 21.4189 24.9311 21.6493 24.0584C22.5206 20.3574 23.0938 16.5925 23.3636 12.7998L12.2871 10.0312Z" fill="#F3F3FD"
        />
        <path
            opacity="0.2"
            d="M34.7293 14.7852C36.3998 18.2805 37.7622 21.915 38.8007 25.6473C39.0375 26.5183 39.0999 27.4275 38.9844 28.3226C38.869 29.2178 38.578 30.0814 38.1281 30.8638C37.6781 31.6463 37.0781 32.3322 36.3625 32.8823C35.6469 33.4323 34.8298 33.8357 33.9579 34.0692C33.0861 34.3028 32.1767 34.3619 31.2819 34.2432C30.3872 34.1245 29.5247 33.8304 28.7439 33.3776C27.963 32.9249 27.2793 32.3224 26.7318 31.6048C26.1844 30.8872 25.784 30.0686 25.5536 29.1959C24.4822 25.1844 23.955 21.053 23.7129 17.5409L34.7293 14.7852Z" fill="#F3F3FD"
        />
        <path
            d="M23.6012 8.56975L30.4584 6.85547C30.4584 6.85547 36.1326 15.7162 38.7941 25.6505C39.0308 26.5215 39.0932 27.4306 38.9778 28.3258C38.8623 29.221 38.5713 30.0846 38.1214 30.867C37.6715 31.6495 37.0715 32.3354 36.3559 32.8854C35.6403 33.4355 34.8231 33.8389 33.9512 34.0724C33.0794 34.306 32.17 34.3651 31.2753 34.2464C30.3805 34.1277 29.518 33.8336 28.7372 33.3808C27.9564 32.928 27.2726 32.3256 26.7252 31.608C26.1777 30.8904 25.7773 30.0717 25.5469 29.199C22.8855 19.2648 23.6012 8.56975 23.6012 8.56975Z" stroke="#F3F3FD" stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M33.9434 34.0488L37.0205 45.5281" stroke="#F3F3FD" stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M42.4595 44.0742L32.1738 46.8299" stroke="#F3F3FD" stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M23.595 3.42913L16.7378 1.71484C16.7378 1.71484 11.0636 10.5756 8.40212 20.5098C8.16541 21.3808 8.10299 22.29 8.21842 23.1852C8.33386 24.0803 8.62489 24.9439 9.07482 25.7264C9.52475 26.5088 10.1247 27.1948 10.8403 27.7448C11.5559 28.2949 12.3731 28.6982 13.245 28.9318C14.1168 29.1653 15.0262 29.2245 15.9209 29.1058C16.8157 28.9871 17.6782 28.6929 18.459 28.2402C19.2398 27.7874 19.9236 27.1849 20.471 26.4673C21.0185 25.7497 21.4189 24.9311 21.6493 24.0584C24.0857 14.1006 23.595 3.42913 23.595 3.42913Z" stroke="#F3F3FD" stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M13.2549 28.9062L10.1777 40.3855" stroke="#F3F3FD" stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M4.74023 38.9297L15.0259 41.6854" stroke="#F3F3FD" stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M23.7012 17.5452L34.7262 14.7852" stroke="#F3F3FD" stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M23.3635 12.7998L12.2871 10.0312" stroke="#F3F3FD" stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </g>
    <defs>
        <clipPath id="clip0_459_24107">
            <rect width="45.2571" height="48" fill="white" />
        </clipPath>
    </defs>
</svg>
</template>
